<template>
  <div class="grid-loader" :class="{ full: full }">
    <div class="lds-grid" :class="{ complete: done && !error, failed: done && error }"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
  </div>
</template>

<script>
export default {
  name: 'GridLoader',
  props: {
    error: Boolean,
    done: {
      type: Boolean,
      required: false
    },
    full: {
      type: Boolean,
      required: false
    }
  },
  watch: {
    done () {
      this.$emit('complete')
    }
  }
}
</script>

<style lang="scss">
  .full {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 99999991;
    height: 100vh;
    width: 100%;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .lds-grid {
    display: inline-block;
    position: relative;
    width: 64px;
    height: 64px;

    &.complete {
      div {
        background: $green !important;
        animation-iteration-count: 5;
      }
    }

    &.failed {
      div {
        background: $red !important;
        animation-iteration-count: 5;
      }
    }
  }

  .lds-grid div {
    position: absolute;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: $main;
    animation: lds-grid 1.2s linear infinite;
    transition: background-color 1s linear;  
  }

  .lds-grid div:nth-child(1) {
    top: 6px;
    left: 6px;
    animation-delay: 0s;
  }
  .lds-grid div:nth-child(2) {
    top: 6px;
    left: 26px;
    animation-delay: -0.4s;
  }
  .lds-grid div:nth-child(3) {
    top: 6px;
    left: 45px;
    animation-delay: -0.8s;
  }
  .lds-grid div:nth-child(4) {
    top: 26px;
    left: 6px;
    animation-delay: -0.4s;
  }
  .lds-grid div:nth-child(5) {
    top: 26px;
    left: 26px;
    animation-delay: -0.8s;
  }
  .lds-grid div:nth-child(6) {
    top: 26px;
    left: 45px;
    animation-delay: -1.2s;
  }
  .lds-grid div:nth-child(7) {
    top: 45px;
    left: 6px;
    animation-delay: -0.8s;
  }
  .lds-grid div:nth-child(8) {
    top: 45px;
    left: 26px;
    animation-delay: -1.2s;
  }
  .lds-grid div:nth-child(9) {
    top: 45px;
    left: 45px;
    animation-delay: -1.6s;
  }

  @keyframes lds-grid {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/loaders/GridLoader.vue